export const ROUTER_CHANGE = 'ROUTER_CHANGE';

export const routerActions = {
  notifyRouterChange: (value) => ({
    type: ROUTER_CHANGE,
    payload: value
  })
};
